import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="min-h-screen bg-[#0f172a] flex flex-col items-center justify-center text-white px-6">
      <h1 className="text-6xl md:text-7xl font-extrabold tracking-tight mb-4">
        404
      </h1>
      <p className="text-xl md:text-2xl mb-2 text-gray-300">Page not found</p>
      <p className="text-md text-gray-400 mb-8 text-center max-w-md">
        The page you're looking for doesn't exist or may have been moved. Try
        going back to the homepage.
      </p>

      <Link
        to="/"
        className="inline-block px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-semibold transition"
      >
        Go to Homepage
      </Link>

    </div>
  );
};

export default NotFound;
